// TODO: that will be remove, when switch to variant
export var RcLinkTypographies = {
    small: 'caption1',
    medium: 'body1',
    large: 'headline1',
};
